import { useSearchParams } from "react-router-dom";

export const TeamFilterType = {
    Search: 'search',
    Page: 'page',
    PageSize: 'page_size',
} as const;

export type TeamFilterType = typeof TeamFilterType[keyof typeof TeamFilterType];


export default function useGetTeamsFiltersQuery() {
    const [searchParams] = useSearchParams();

    const pageQuery = searchParams.get(TeamFilterType.Page);
    const pageSizeQuery = searchParams.get(TeamFilterType.PageSize);
    const searchQuery = searchParams.get(TeamFilterType.Search);

    return {
        searchQuery,
        pageSizeQuery,
        pageQuery,
    };
}
